module.exports = __webpack_public_path__ + "img/kita_no.e14f433e.png";